module.exports = __webpack_public_path__ + "static/media/stbMainMenuLogo.aea7496f.png";